//#region ../icons/dist/html/compat/switches.js
const switchesIcon = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"18\" height=\"18\" fill=\"currentColor\" aria-hidden=\"true\" viewBox=\"0 0 18 18\"><path d=\"M12.5 1a3.5 3.5 0 1 1 0 7h-7a3.5 3.5 0 1 1 0-7zm-7 2a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m7 7a3.5 3.5 0 1 1 0 7h-7a3.5 3.5 0 1 1 0-7zm0 2a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3\"/></svg>";
//#endregion
export { switchesIcon };
